(function () {
  'use strict';

  var PROPERTY_KEY = '_MultipleOfferTier';
  var UPDATE_EVENT = 'cart-tier-offers:updated';
  var productTagCache = {};
  var DEFAULT_SETTINGS = {
    showCartDrawerProgress: true,
    showProductProgress: true,
    showCartDrawerBarVisual: true,
    showProductBarVisual: true,
    activeColor: '#00ff00',
    excludedProductTags: [],
    cartItemTags: {}
  };

  window.CartTierOfferGlobal = window.CartTierOfferGlobal || {
    offers: [],
    settings: DEFAULT_SETTINGS,
    isProcessing: false,
    needsProcessing: false,
    lastState: null
  };
  window.CartTierOfferGlobal.settings = Object.assign({}, DEFAULT_SETTINGS, window.CartTierOfferGlobal.settings || {});

  function cartRoute(routeName, fallback) {
    var route = window.themeVariables && window.themeVariables.routes && window.themeVariables.routes[routeName];
    return route || fallback;
  }

  function withJs(url) {
    return /\.js(?:\?|$)/.test(url) ? url : url + '.js';
  }

  function normalizeNumber(value) {
    var number = parseFloat(value);
    return Number.isFinite(number) ? number : 0;
  }

  function normalizeBoolean(value) {
    return value === true || value === 'true';
  }

  function normalizeList(value) {
    return (Array.isArray(value) ? value : String(value || '').split(/[\n,]/))
      .map(function (item) {
        return String(item || '').trim().toLowerCase();
      })
      .filter(Boolean);
  }

  function normalizeOffer(offer, index) {
    var tierLimit = normalizeNumber(offer.tier_limit || offer.cart_total);
    var propertyName = offer.property_name || offer.propery_name || offer.title || 'tier-' + (index + 1);
    var freebieProduct = parseInt(offer.freebie_product, 10);

    return {
      title: offer.title || propertyName,
      tier_limit: tierLimit,
      pre_message: offer.pre_message || '',
      post_message: offer.post_message || '',
      freebie_product: Number.isFinite(freebieProduct) ? freebieProduct : null,
      property_name: String(propertyName),
      icon_for_progress_bar: offer.icon_for_progress_bar || '',
      offer_text: offer.offer_text || offer.title || propertyName,
      dont_auto_remove: normalizeBoolean(offer.dont_auto_remove)
    };
  }

  function normalizeOffers(offers) {
    return (Array.isArray(offers) ? offers : [])
      .map(normalizeOffer)
      .filter(function (offer) {
        return offer.tier_limit > 0;
      })
      .sort(function (a, b) {
        return a.tier_limit - b.tier_limit;
      });
  }

  function normalizeSettings(settings) {
    var source = settings || {};

    return {
      showCartDrawerProgress: source.show_cart_drawer_progress !== false,
      showProductProgress: source.show_product_progress !== false,
      showCartDrawerBarVisual: source.show_cart_drawer_bar_visual !== false,
      showProductBarVisual: source.show_product_bar_visual !== false,
      activeColor: source.active_color || DEFAULT_SETTINGS.activeColor,
      excludedProductTags: normalizeList(source.excluded_product_tags),
      cartItemTags: normalizeCartItemTags(source.cart_items)
    };
  }

  function normalizeCartItemTags(items) {
    var map = {};

    (Array.isArray(items) ? items : []).forEach(function (item) {
      var tags = normalizeList(item && item.tags);

      if (!tags.length) {
        return;
      }

      [item.key, item.variant_id, item.product_id, item.handle].forEach(function (value) {
        if (value !== undefined && value !== null && value !== '') {
          map[String(value)] = tags;
        }
      });
    });

    return map;
  }

  function formatMoney(cents) {
    var currency = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartCurrency) || 'INR';

    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 0
      }).format(cents / 100);
    } catch (error) {
      if (typeof window.formatMoney === 'function') {
        return window.formatMoney(cents);
      }

      return 'Rs. ' + Math.round(cents / 100).toLocaleString('en-IN');
    }
  }

  function fetchCart() {
    return fetch(withJs(cartRoute('cartUrl', '/cart')), {
      credentials: 'same-origin'
    }).then(function (response) {
      return response.json();
    });
  }

  function lineItemTierName(item) {
    return item && item.properties ? item.properties[PROPERTY_KEY] : null;
  }

  function isTierFreebie(item) {
    return Boolean(lineItemTierName(item));
  }

  function itemHandle(item) {
    if (!item) {
      return '';
    }

    if (item.handle) {
      return String(item.handle).toLowerCase();
    }

    if (item.url) {
      var parts = String(item.url).split('?')[0].split('/products/');
      return parts[1] ? parts[1].split('/')[0].toLowerCase() : '';
    }

    return '';
  }

  function lineItemTags(item) {
    if (!item) {
      return [];
    }

    if (item.product_tags) {
      return normalizeList(item.product_tags);
    }

    if (item.tags) {
      return normalizeList(item.tags);
    }

    if (item.product && item.product.tags) {
      return normalizeList(item.product.tags);
    }

    return [];
  }

  function mappedLineItemTags(item, settings) {
    var tagMap = (settings && settings.cartItemTags) || window.CartTierOfferGlobal.settings.cartItemTags || {};
    var keys = [
      item && item.key,
      item && item.variant_id,
      item && item.id,
      item && item.product_id,
      itemHandle(item)
    ];

    for (var index = 0; index < keys.length; index += 1) {
      var key = keys[index];

      if (key !== undefined && key !== null && tagMap[String(key)]) {
        return tagMap[String(key)];
      }
    }

    return [];
  }

  function fetchProductTags(item, settings) {
    var inlineTags = lineItemTags(item);
    var mappedTags = mappedLineItemTags(item, settings);
    var handle = itemHandle(item);

    if (inlineTags.length) {
      return Promise.resolve(inlineTags);
    }

    if (mappedTags.length) {
      return Promise.resolve(mappedTags);
    }

    if (!handle) {
      return Promise.resolve([]);
    }

    if (!productTagCache[handle]) {
      productTagCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin'
      })
        .then(function (response) {
          if (!response.ok) {
            return [];
          }

          return response.json();
        })
        .then(function (product) {
          return normalizeList(product && product.tags);
        })
        .catch(function () {
          return [];
        });
    }

    return productTagCache[handle];
  }

  function hasMatchingExcludedTag(tags, excludedTags) {
    if (!tags.length || !excludedTags.length) {
      return false;
    }

    return tags.some(function (tag) {
      return excludedTags.indexOf(tag) !== -1;
    });
  }

  async function isExcludedLineItem(item, settings) {
    var config = settings || window.CartTierOfferGlobal.settings || DEFAULT_SETTINGS;
    var excludedTags = config.excludedProductTags || [];

    if (!excludedTags.length) {
      return false;
    }

    return hasMatchingExcludedTag(await fetchProductTags(item, config), excludedTags);
  }

  async function calculateEligibleCartTotal(cart, settings) {
    if (!cart || !Array.isArray(cart.items)) {
      return 0;
    }

    var config = settings || window.CartTierOfferGlobal.settings || DEFAULT_SETTINGS;
    var excludedTags = config.excludedProductTags || [];
    var total = 0;

    // Resolve every line item's tags in parallel up front. The previous
    // implementation awaited inside the loop, which serialized one
    // /products/{handle}.js round-trip per uncached item — the dominant
    // latency source when excluded tags are configured.
    var tagLists = await Promise.all(cart.items.map(function (item) {
      return excludedTags.length ? fetchProductTags(item, config) : Promise.resolve([]);
    }));

    for (var index = 0; index < cart.items.length; index += 1) {
      var item = cart.items[index];
      var tags = tagLists[index] || [];
      var isFreebie = isTierFreebie(item);
      var isTagExcluded = hasMatchingExcludedTag(tags, excludedTags);
      var linePrice = typeof item.final_line_price === 'number'
        ? item.final_line_price
        : (typeof item.line_price === 'number' ? item.line_price : (item.original_line_price || 0));

      if (isFreebie || isTagExcluded) {
        continue;
      }

      total += linePrice;
    }

    return total;
  }

  function getUnlockedTiers(offers, cartTotalCents) {
    var cartTotal = cartTotalCents / 100;
    return offers.filter(function (offer) {
      return cartTotal >= offer.tier_limit;
    });
  }

  async function buildState(cart, offers, settings) {
    var cartTotalCents = await calculateEligibleCartTotal(cart, settings);
    var unlockedTiers = getUnlockedTiers(offers, cartTotalCents);

    return {
      cart: cart,
      offers: offers,
      settings: settings || window.CartTierOfferGlobal.settings || DEFAULT_SETTINGS,
      itemCount: cart && typeof cart.item_count === 'number' ? cart.item_count : 0,
      cartTotalCents: cartTotalCents,
      cartTotal: cartTotalCents / 100,
      unlockedTierNames: unlockedTiers.map(function (offer) {
        return offer.property_name;
      })
    };
  }

  function dispatchState(state) {
    window.CartTierOfferGlobal.lastState = state;
    document.dispatchEvent(new CustomEvent(UPDATE_EVENT, {
      bubbles: true,
      detail: state
    }));
  }

  function cartRefresh() {
    // Stamp the refresh time so handleCartUpdated can ignore the cart:updated
    // it bounces back (preventing a redundant second cycle). A timestamp window
    // is used instead of a sticky flag so a genuine later update is never
    // accidentally swallowed if the re-render doesn't re-fire the event.
    window.CartTierOfferGlobal._selfRefreshAt = Date.now();
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: {
        openMiniCart: false
      }
    }));
  }

  class CartTierOfferManager extends HTMLElement {
    constructor() {
      super();
      this.offers = [];
      this.settings = DEFAULT_SETTINGS;
      this.handleCartUpdated = this.handleCartUpdated.bind(this);
    }

    connectedCallback() {
      this.parseConfig();

      if (!this.offers.length) {
        return;
      }

      window.CartTierOfferGlobal.offers = this.offers;
      window.CartTierOfferGlobal.settings = this.settings;
      document.documentElement.addEventListener('cart:updated', this.handleCartUpdated);
      this.process();
    }

    disconnectedCallback() {
      document.documentElement.removeEventListener('cart:updated', this.handleCartUpdated);
    }

    parseConfig() {
      var configScript = this.querySelector('script[type="application/json"]');

      if (!configScript) {
        return;
      }

      try {
        var config = JSON.parse(configScript.textContent);
        this.offers = normalizeOffers(config.offers);
        this.settings = normalizeSettings(Object.assign({}, config.settings, {
          cart_items: config.cart_items
        }));
      } catch (error) {
        this.offers = [];
        this.settings = DEFAULT_SETTINGS;
        console.error('[CartTierOffers] Unable to parse offer config.', error);
      }
    }

    handleCartUpdated(event) {
      var global = window.CartTierOfferGlobal;

      // Ignore the cart:updated that our own cartRefresh() triggers — it would
      // otherwise re-run the whole cycle a second time with nothing to change.
      // Only swallow events that arrive within a short window of our refresh.
      if (global._selfRefreshAt && (Date.now() - global._selfRefreshAt) < 1200) {
        global._selfRefreshAt = 0;
        return;
      }

      var presetCart = event && event.detail && event.detail.cart;
      this.process(presetCart);
    }

    async process(presetCart) {
      var global = window.CartTierOfferGlobal;

      if (global.isProcessing) {
        global.needsProcessing = true;
        return;
      }

      global.isProcessing = true;

      try {
        // The cart:updated event already carries the cart snapshot, so reuse
        // it instead of paying an extra round-trip on every cart change.
        var cart = presetCart || await fetchCart();
        var state = await buildState(cart, this.offers, this.settings);

        // Plan all add/remove operations up front. Freebies are filtered out
        // of the eligible cart total via isTierFreebie(), so we can decide
        // every offer's actions from a single cart snapshot — no need to
        // re-fetch the cart between offers like the old loop did.
        var plan = { add: [], removeKeys: [], updates: [] };
        for (var index = 0; index < this.offers.length; index += 1) {
          var offer = this.offers[index];
          var isUnlocked = state.unlockedTierNames.indexOf(offer.property_name) !== -1;
          this.planOfferOps(offer, isUnlocked, cart, plan);
        }

        var changed = plan.add.length > 0 || plan.removeKeys.length > 0 || plan.updates.length > 0;

        if (changed) {
          cart = await this.executePlan(plan, cart);
          // Adding/removing freebies cannot change the eligible total —
          // freebies are filtered out of it (isTierFreebie). So reuse the
          // total/unlocked tiers we already computed and only refresh the
          // cart snapshot + item count, skipping a second eligibility pass.
          state = Object.assign({}, state, {
            cart: cart,
            itemCount: cart && typeof cart.item_count === 'number' ? cart.item_count : state.itemCount
          });
        }

        dispatchState(state);

        if (changed) {
          cartRefresh();
        }
      } catch (error) {
        console.error('[CartTierOffers] Unable to process cart tier offers.', error);
      } finally {
        global.isProcessing = false;

        if (global.needsProcessing) {
          global.needsProcessing = false;
          this.process();
        }
      }
    }

    planOfferOps(offer, isUnlocked, cart, plan) {
      if (!offer.freebie_product || !cart || !Array.isArray(cart.items)) {
        return;
      }

      var tierItems = cart.items.filter(function (item) {
        return lineItemTierName(item) === offer.property_name;
      });
      var exactFreebie = tierItems.find(function (item) {
        return item.variant_id === offer.freebie_product || item.id === offer.freebie_product;
      });

      if (isUnlocked) {
        if (!exactFreebie && tierItems.length === 0) {
          plan.add.push({
            id: offer.freebie_product,
            quantity: 1,
            properties: (function () {
              var props = {};
              props[PROPERTY_KEY] = offer.property_name;
              return props;
            })()
          });
          return;
        }

        if (tierItems.length > 1) {
          // Keep the first tier line item, mark the rest for removal.
          for (var i = 1; i < tierItems.length; i += 1) {
            plan.removeKeys.push(tierItems[i].key);
          }
        }

        var freebieLine = exactFreebie || tierItems[0];
        if (freebieLine && freebieLine.quantity !== 1) {
          plan.updates.push({ id: freebieLine.key, quantity: 1 });
        }

        return;
      }

      if (tierItems.length > 0 && !offer.dont_auto_remove) {
        for (var j = 0; j < tierItems.length; j += 1) {
          plan.removeKeys.push(tierItems[j].key);
        }
      }
    }

    async executePlan(plan, fallbackCart) {
      // Run all removes in parallel — they're independent line items.
      // Then issue a single /cart/add.js with the full batched items array.
      // Use the response from the last call as the new cart snapshot, which
      // avoids an extra round-trip to /cart.js at the end.
      var latestCart = fallbackCart;
      var headers = {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      };

      if (plan.updates.length > 0) {
        var updateUrl = withJs(cartRoute('cartChangeUrl', '/cart/change'));
        var updateResponses = await Promise.all(plan.updates.map(function (update) {
          return fetch(updateUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: headers,
            body: JSON.stringify({ id: update.id, quantity: update.quantity })
          });
        }));

        for (var u = 0; u < updateResponses.length; u += 1) {
          var ur = updateResponses[u];
          if (!ur.ok) {
            console.error('[CartTierOffers] Unable to reset freebie quantity.', await ur.text());
            continue;
          }
          if (u === updateResponses.length - 1) {
            try { latestCart = await ur.json(); } catch (e) { /* keep fallback */ }
          }
        }
      }

      if (plan.removeKeys.length > 0) {
        var removeUrl = withJs(cartRoute('cartChangeUrl', '/cart/change'));
        var removeResponses = await Promise.all(plan.removeKeys.map(function (key) {
          return fetch(removeUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: headers,
            body: JSON.stringify({ id: key, quantity: 0 })
          });
        }));

        for (var r = 0; r < removeResponses.length; r += 1) {
          var rr = removeResponses[r];
          if (!rr.ok) {
            console.error('[CartTierOffers] Unable to remove freebie.', await rr.text());
            continue;
          }
          // Only keep the last successful response as our cart snapshot.
          if (r === removeResponses.length - 1) {
            try { latestCart = await rr.json(); } catch (e) { /* keep fallback */ }
          }
        }
      }

      if (plan.add.length > 0) {
        var addResponse = await fetch(withJs(cartRoute('cartAddUrl', '/cart/add')), {
          method: 'POST',
          credentials: 'same-origin',
          headers: headers,
          body: JSON.stringify({ items: plan.add })
        });

        if (!addResponse.ok) {
          console.error('[CartTierOffers] Unable to add freebie(s).', await addResponse.text());
        } else {
          // /cart/add.js returns the added items, not the full cart, so
          // refetch once to get the canonical state.
          latestCart = await fetchCart();
        }
      }

      return latestCart;
    }
  }

  class CartTierProgressBar extends HTMLElement {
    constructor() {
      super();
      this.handleUpdate = this.handleUpdate.bind(this);
    }

    connectedCallback() {
      this.messageElement = this.querySelector('[data-tier-message]');
      this.fillElement = this.querySelector('[data-tier-progress-fill]');
      this.markersElement = this.querySelector('[data-tier-progress-markers]');
      document.addEventListener(UPDATE_EVENT, this.handleUpdate);

      if (window.CartTierOfferGlobal.lastState) {
        this.render(window.CartTierOfferGlobal.lastState);
      } else {
        this.loadInitialState();
      }
    }

    disconnectedCallback() {
      document.removeEventListener(UPDATE_EVENT, this.handleUpdate);
    }

    async loadInitialState() {
      var offers = window.CartTierOfferGlobal.offers || [];

      if (!offers.length) {
        return;
      }

      try {
        var cart = await fetchCart();
        var state = await buildState(cart, offers, window.CartTierOfferGlobal.settings);
        this.render(state);
      } catch (error) {
        console.error('[CartTierOffers] Unable to render initial progress.', error);
      }
    }

    handleUpdate(event) {
      this.render(event.detail);
    }

    render(state) {
      var offers = normalizeOffers(state && state.offers);
      var settings = this.settingsForState(state);

      if (!offers.length || this.shouldHideForCart(state)) {
        this.hidden = true;
        return;
      }

      this.applySettings(settings);
      this.applyBarVisibility(settings);
      this.hidden = false;
      this.renderMarkers(offers, state.cartTotal || 0);
      this.renderFill(offers, state.cartTotal || 0);
      this.renderMessage(offers, state.cartTotal || 0);
    }

    applyBarVisibility(settings) {
      // Toggles the bar-visual modifier class so the message stays visible
      // even when the merchant has chosen to hide just the bar/track/markers.
      var context = this.getAttribute('data-context') || '';
      var hideBar = false;
      if (context === 'cart-drawer' && settings.showCartDrawerBarVisual === false) {
        hideBar = true;
      }
      if (context === 'product' && settings.showProductBarVisual === false) {
        hideBar = true;
      }
      this.classList.toggle('cart-tier-progress-bar--no-bar', hideBar);
    }

    shouldHideForCart(state) {
      var hideWhenEmpty = this.getAttribute('data-hide-when-empty') === 'true';
      var settings = this.settingsForState(state);
      var context = this.getAttribute('data-context') || '';

      if (context === 'cart-drawer' && settings.showCartDrawerProgress === false) {
        return true;
      }

      if (context === 'product' && settings.showProductProgress === false) {
        return true;
      }

      return hideWhenEmpty && (!state || state.itemCount === 0);
    }

    settingsForState(state) {
      return (state && state.settings) || window.CartTierOfferGlobal.settings || DEFAULT_SETTINGS;
    }

    applySettings(settings) {
      if (settings.activeColor) {
        this.style.setProperty('--cart-tier-active-color', settings.activeColor);
      }
    }

    renderMarkers(offers, cartTotal) {
      if (!this.markersElement) {
        return;
      }

      var totalCount = offers.length;
      var maxOffer = offers[totalCount - 1];
      var maxLimit = maxOffer && maxOffer.tier_limit > 0 ? maxOffer.tier_limit : 0;
      this.markersElement.innerHTML = '';

      offers.forEach((function (offer, index) {
        var position = this.positionForOffer(offer, index, totalCount, maxLimit);
        var marker = document.createElement('div');
        marker.className = 'cart-tier-progress__marker' + (cartTotal >= offer.tier_limit ? ' is-active' : '');
        marker.style.left = position + '%';
        marker.dataset.tier = offer.property_name;

        var price = document.createElement('div');
        price.className = 'cart-tier-progress__price';
        price.textContent = formatMoney(Math.round(offer.tier_limit * 100));
        marker.appendChild(price);

        var icon = document.createElement('div');
        icon.className = 'cart-tier-progress__icon';

        if (offer.icon_for_progress_bar) {
          var image = document.createElement('img');
          image.src = offer.icon_for_progress_bar;
          image.alt = offer.offer_text || offer.title || 'Cart offer';
          image.width = 42;
          image.height = 42;
          icon.appendChild(image);
        } else {
          var fallback = document.createElement('span');
          fallback.className = 'cart-tier-progress__fallback-icon';
          fallback.textContent = 'Gift';
          icon.appendChild(fallback);
        }

        marker.appendChild(icon);

        if (offer.offer_text) {
          var label = document.createElement('span');
          label.className = 'cart-tier-progress__label';
          label.textContent = offer.offer_text;
          marker.appendChild(label);
        }

        this.markersElement.appendChild(marker);
      }).bind(this));
    }

    renderFill(offers, cartTotal) {
      if (!this.fillElement) {
        return;
      }

      this.fillElement.style.width = this.calculateFillPercent(offers, cartTotal) + '%';
    }

    renderMessage(offers, cartTotal) {
      if (!this.messageElement) {
        return;
      }

      var message = '';
      var maxOffer = offers[offers.length - 1];

      if (cartTotal >= maxOffer.tier_limit) {
        message = maxOffer.post_message || 'All offers unlocked.';
      } else {
        var nextIndex = offers.findIndex(function (offer) {
          return cartTotal < offer.tier_limit;
        });
        var nextOffer = offers[nextIndex];
        var remainingCents = Math.max(0, Math.round((nextOffer.tier_limit - cartTotal) * 100));
        var template = nextOffer.pre_message || 'You are [amount] away from ' + (nextOffer.offer_text || nextOffer.title || 'the next offer');

        message = template
          .replace(/\[amount\]/g, formatMoney(remainingCents))
          .replace(/\{\{\s*amount\s*\}\}/g, formatMoney(remainingCents))
          .replace(/\|\|amount\|\|/g, formatMoney(remainingCents));
      }

      this.messageElement.textContent = message;
      this.messageElement.hidden = !message;
    }

    positionForOffer(offer, index, totalCount, maxLimit) {
      // Markers are positioned proportionally to their tier_limit so they line up
      // with where the fill bar actually reaches at that threshold. The last
      // marker is pulled in slightly so its label doesn't overflow the bar.
      var end = 95;

      if (totalCount <= 1 || !maxLimit) {
        return end;
      }

      if (index === totalCount - 1) {
        return end;
      }

      var ratio = offer.tier_limit / maxLimit;
      return Math.max(0, Math.min(ratio * 100, end));
    }

    calculateFillPercent(offers, cartTotal) {
      var maxOffer = offers[offers.length - 1];

      if (!maxOffer || maxOffer.tier_limit <= 0) {
        return 0;
      }

      // Cap at 95% to match the last marker's pulled-in position so the fill
      // doesn't visually overshoot the final marker once it's unlocked.
      var cap = 95;
      return Math.max(0, Math.min((cartTotal / maxOffer.tier_limit) * cap, cap));
    }
  }

  if (!customElements.get('cart-tier-offer-manager')) {
    customElements.define('cart-tier-offer-manager', CartTierOfferManager);
  }

  if (!customElements.get('cart-tier-progress-bar')) {
    customElements.define('cart-tier-progress-bar', CartTierProgressBar);
  }
})();
